import getConfig from 'next/config'

// Flags
export const isDev = process.env.NODE_ENV === 'development'
export const isMockEnabled = process.env.NEXT_PUBLIC_MSW_ENABLED === 'true'
export const isTest = process.env.NODE_ENV === 'test'
export const isJest = typeof process.env.JEST_WORKER_ID !== 'undefined'
export const isOpenResty = process.env.NEXT_PUBLIC_OPEN_RESTY === 'true'

// Check if the environment is server-side
export const isServer = typeof window === 'undefined'

// runtime environment keys
export enum EEnvironments {
  DEVELOPMENT = 'dev',
  TESTING = 'tst',
  STAGING = 'stg',
  PRODUCTION = 'prd',
}

const { publicRuntimeConfig } = getConfig()

export const HOST_URL = publicRuntimeConfig.HOST_URL
export const AUTHENTICATION_PATH_URL =
  isOpenResty || !isDev ? publicRuntimeConfig.AUTHENTICATION_PATH_URL : '/auth/login'

export const isProd = publicRuntimeConfig.ENVIRONMENT === EEnvironments.PRODUCTION
